import { fetchGetPhrases } from "./fetchGetPhrases";

export const translationsFailedToLoad = "translations-failed-to-load";

export async function translationsFromPhrases(
  languageId?: string,
  country?: string
) {
  const phrases = await fetchGetPhrases(languageId ?? "en", country ?? "US");

  return phrases.tag === "successful"
    ? phrases.parsed
    : {
        [translationsFailedToLoad]: "Translations Failed to Load",
      };
}
